import React, { useRef, useState } from 'react'
import { FileDrop } from 'react-file-drop'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { uploadReports } from '../../actions/InterBranchCoordinatorAction'
import { INTERBRANCH_MODAL_UPDATE } from '../../actions/type'
import axios from "axios";
// import { addFileToRedux } from '../../Redux/Slice/ModalSlice'
import EmptyReport from './EmptyReport'
import FilesList from './FilesList'
import { SERVER_API_URL } from "../../apis";
import './reportsuploader.css'

function ReportsUploader() {

    let [_files, setFiles] = useState([])
    const fileInputRef = useRef(null);

    let dispatch = useDispatch()

    // let allowdType = [".pdf", ".png", ".jpeg", ".jpg", ".doc", ".docx", ".dcm", ".zip"]
    let allowdType = [".pdf", ".png", ".jpeg", ".jpg", ".doc", ".docx", ".dcm"]

    const reportsUploaded = useSelector((state) => state?.interBranchCoordinator?.temp_appointment_form?.reportsUploaded)
    const [reports, setReports] = useState((state) => state?.interBranchCoordinator?.appointment_form?.reports);

   
   
    const onFileInputChange = (event) => {
        const { files } = event.target;
        

        if (!reportsUploaded || (reportsUploaded && reportsUploaded.length < 5)) {
            const formData = new FormData();
            formData.append("name", files[0].name);
            formData.append("file", files[0]);
            console.log("Uploading Reports through axios",files)

            axios
                .post(SERVER_API_URL + "/reportsuploads", formData, {})
                .then((res) => {

                    console.log("Response from upload reports",res);
                    // setReports([...reports,res?.data?.data?.fileName])

                    dispatch(uploadReports({
                        prevReports:reportsUploaded,
                        files: files[0],
                        name: res?.data?.data?.fileName?res?.data?.data?.fileName:files[0].name
                    }))
                })



        }
        else {
            dispatch({
                type: INTERBRANCH_MODAL_UPDATE,
                payload: { modalName: "commomAlertModal", isVisible: true, data: "Only 5 files are allowed to upload" }
            })
        }
    }



    const handleDrop = (files) => {

        let allowdTypeDrop = ["application/pdf", "image/png", "image/jpeg", "image/jpg", "application/doc", "application/msword", "application/docx", "application/dcm"]

        console.log(files);

        if (allowdTypeDrop.includes(files[0]?.type)) {

            if (!reportsUploaded || (reportsUploaded && reportsUploaded.length < 5)) {

                const formData = new FormData();
                formData.append("name", files[0].name);
                formData.append("file", files[0]);
                console.log("Uploading Reports through axios")

                axios
                   .post(SERVER_API_URL + "/reportsuploads", formData, {})
                    .then((res) => {

                        // console.log("Response from upload reports", res);
                        // setReports(...reports,res.data.data.fileName);

                        dispatch(uploadReports({
                            prevReports:reportsUploaded,
                            files: files[0],
                            name: res?.data?.data?.fileName
                        }))
                    })


            }
            else {

                dispatch({
                    type: INTERBRANCH_MODAL_UPDATE,
                    payload: { modalName: "commomAlertModal", isVisible: true, data: "Maximum 5 files only allowed." }
                })

            }

        }
        else {

            dispatch({
                type: INTERBRANCH_MODAL_UPDATE,
                payload: { modalName: "commomAlertModal", isVisible: true, data: "File type not supported." }
            })

        }




    }

    const onTargetClick = () => {
        fileInputRef.current.click()
    }


   


   
    return (
        <FileDrop
            accept={allowdType}
            // onFrameDragEnter={(event) => console.log('onFrameDragEnter', event)}
            // onFrameDragLeave={(event) => console.log('onFrameDragLeave', event)}
            // onFrameDrop={(event) => console.log('onFrameDrop', event)}
            // onDragOver={(event) => console.log('onDragOver', event)}
            // onDragLeave={(event) => console.log('onDragLeave', event)}
            onDrop={(files, event) => handleDrop(files, event)}
        >
            <input
                onChange={onFileInputChange}
                ref={fileInputRef}
                type="file"
                accept={allowdType}
                className="hidden"
            />

            {
                reportsUploaded && reportsUploaded.length > 0 ?
                    <FilesList files={reportsUploaded} onTargetClick={onTargetClick} />
                    : <EmptyReport onTargetClick={onTargetClick} />

            }



        </FileDrop>
    )
}

export default ReportsUploader
